const CADEIA = [
  'Operadora',
  'Administradora',
  'Assessoria',
  'Corretor',
  'Venda',
  'Validação',
  'GetPoints',
  'Premiação',
];

const PERFIS = [
  { perfil: 'Corretor', exemplo: '20 contratos → 5.000 pontos', icon: 'ri-user-star-line' },
  { perfil: 'Gerente comercial', exemplo: 'Meta da equipe atingida → premiação', icon: 'ri-flag-2-line' },
  { perfil: 'Assessoria', exemplo: 'Volume de vendas → faixa de recompensa', icon: 'ri-building-2-line' },
  { perfil: 'Parceiro', exemplo: 'Indicação convertida → pontos', icon: 'ri-hand-heart-line' },
];

const RETENCAO = [
  'Renovação de contrato',
  'Manutenção de carteira',
  'Recuperação de clientes',
  'Redução de churn',
  'Relacionamento com empresas',
];

const EQUIPE = {
  nome: 'Desafio Comercial 2026',
  meta: 'R$ 2 milhões',
  realizado: 'R$ 1,8 milhão',
  progresso: 90,
};

export default function CanaisCorretores() {
  return (
    <section id="canais" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Canais de venda
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Incentivo para cada elo <span className="text-accent-600">da cadeia</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">
            A GetPoints atua como uma camada tecnológica de incentivo entre os participantes da cadeia de distribuição de planos de saúde.
          </p>
        </div>

        <div className="mb-12 flex flex-wrap items-center justify-center gap-2">
          {CADEIA.map((item, index) => (
            <div key={item} className="flex items-center gap-2">
              <span
                className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-semibold ${
                  item === 'GetPoints'
                    ? 'bg-primary-500 text-white'
                    : 'border border-background-200 bg-background-50 text-foreground-700'
                }`}
              >
                {item}
              </span>
              {index < CADEIA.length - 1 && (
                <span className="text-foreground-300">
                  <i className="ri-arrow-down-line text-sm sm:hidden"></i>
                  <i className="ri-arrow-right-line text-sm hidden sm:block"></i>
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          <article className="rounded-3xl border border-background-200 bg-background-50 p-7 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">Campanhas por perfil</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              Cada participante da cadeia recebe uma campanha específica, com metas e premiações próprias.
            </p>
            <div className="mt-6 space-y-3">
              {PERFIS.map((item) => (
                <div key={item.perfil} className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-100 px-4 py-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-base`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{item.perfil}</p>
                    <p className="text-xs text-foreground-500">{item.exemplo}</p>
                  </div>
                </div>
              ))}
            </div>
          </article>

          <article className="rounded-3xl border border-background-200 bg-background-50 p-7 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">Fidelização e retenção</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              Campanhas de permanência de carteira: contrato ativo + critérios da campanha atendidos → geração de premiação.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {RETENCAO.map((item) => (
                <span key={item} className="rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-800">
                  {item}
                </span>
              ))}
            </div>
            <p className="mt-6 text-xs leading-relaxed text-foreground-500">
              A plataforma não decide a regra comercial — ela executa exatamente a regra definida pelo cliente.
            </p>
          </article>

          <article className="rounded-3xl border border-background-200 bg-foreground-900 p-7 md:p-8">
            <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">Incentivo para equipes internas</h3>
            <p className="mt-2 text-xs font-medium uppercase tracking-wider text-accent-300">{EQUIPE.nome}</p>
            <div className="mt-6">
              <div className="flex items-end justify-between">
                <p className="text-sm font-semibold text-background-100">Equipe Norte</p>
                <p className="font-heading text-2xl font-bold text-accent-300">{EQUIPE.progresso}%</p>
              </div>
              <div className="mt-3 h-3 overflow-hidden rounded-full bg-white/10">
                <div className="h-full rounded-full bg-accent-400" style={{ width: `${EQUIPE.progresso}%` }}></div>
              </div>
              <div className="mt-4 flex justify-between text-xs text-background-200">
                <span>Meta: {EQUIPE.meta}</span>
                <span>Realizado: {EQUIPE.realizado}</span>
              </div>
            </div>
            <p className="mt-6 text-xs leading-relaxed text-background-200">
              Atende comercial, atendimento, relacionamento, implantação, pós-venda, retenção e operações.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}